import Component from "@tunnel-components/@pages/explorer/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as moment from "moment";
import {
  SystemSettingsActionCreator,
  SearchIncidentByIdActionCreator,
  ImpactFakeDeletedActionCreator,
  IncidentHistoryLoadedActionCreator,
  IncidentHistoryLoadedResetActionCreator,
  ExtractorPdfIncidentActionCreator,
  ReplayDownloadActionCreator,
  ExtractorVideoActionCreator,
  IncidentTypesLoadedActionCreator,
  ExtractorCameraListActionCreator,
} from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next";

moment.locale("en");
/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name  componentWillUnmount
 * @name  componentWillReceiveProps
 * @name  render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * ......
     */

    this.state = {
      arrayOfIncident: [],
      explorerData: [],
      endDate: "",

      currentPageNumbers: 1, // nouvelle //
      filter: [false, false, false, false],
      filterHeader: [false, false, false, false],
      fiterInfos: "",
      openHoverCard: false,
      totalElements: 1,
      itemsPerPage: 1200,
      errorserver: false,
      sorting: "orderBy=start_time&direction=DESC",
      alarmOver: [],
      noIncidents: false,
      noSearchById: true,
      sectionOver: [],
      startTimeOver: [],
      onresetoff: false,
      //
      // QualificationState:["À qualifier", "Fausse alerte", "Avéré", "Inhibé par SAE","Inhibé par WEB","Filtré par WEB"],
      QualificationState: [
        i18next.t("a qualifier"),
        i18next.t("fausse alerte"),
        i18next.t("avere"),
      ],

      actionLoading: [],
      active: [],
      btnloading: false,
      cameraFilter: [],
      cameraSection: [],
      cameraString: "",
      current: 1,
      data: [],
      explorersearch: "",
      errorDateRange: false,
      errorExtractionVideo: false,
      errorExtractionPdf: false,
      errorSearchIncident: false,

      falseAlert: [],

      filterSearch: "",
      incident: [],

      initialisation: true,
      isFilter: false,
      isFilterOff: false,
      isOpen: false,

      labelFilter: [],
      labelString: [],
      labelStrings: "",

      onpensearchboolean: false,
      open: false,
      pageNumbers: [],
      pageVisible: [],
      //  pagination: [3600, 3500, 4000],
      paramArray: 0,
      qualification: [false, false, false],
      qualificationString: [],
      scrollIncident: 0,
      sectionFilter: [],
      sectionString: [],
      sectionStrings: "",
      selectedFilterValue: "",
      selectedValue: 1400,
      startDate: "",
      onresetSuccess: false,
      stableValue: 8,
      startTimeAction: [],
      table: [],
    };

    /**,
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onClose = this.onClose.bind(this); // close filtre
    this.onOpen = this.onOpen.bind(this); // ouverture du filtre
    this.onSortingBy = this.onSortingBy.bind(this);
    // nouvelle //
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);

    // Event Mouse Over
    this.onTextOver = this.onTextOver.bind(this);
    // activation de la box incidents
    this.onIncidentActif = this.onIncidentActif.bind(this);

    // extraire la séquence
    this.onExtractImpact = this.onExtractImpact.bind(this);
    this.onExtractVideo = this.onExtractVideo.bind(this);

    //
    this.onDeletedSimulation = this.onDeletedSimulation.bind(this);
    this.onPenSearchIncidents = this.onPenSearchIncidents.bind(this);
    this.onPenSearchIncidentsClose = this.onPenSearchIncidentsClose.bind(this);
    this.onOpenhoverCard = this.onOpenhoverCard.bind(this);
    this.onClosehoverCard = this.onClosehoverCard.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.onReset = this.onReset.bind(this);

    // Mise à jour de la valeur du ScrollTop
    this.onUpdateScrollTop = this.onUpdateScrollTop.bind(this);

    // Explore search

    this.onExplorerSearch = this.onExplorerSearch.bind(this);
    this.onExplorerSearchChange = this.onExplorerSearchChange.bind(this);
    this.onClearIncidentSearch = this.onClearIncidentSearch.bind(this);

    //
    this.onGetValue = this.onGetValue.bind(this);
    this.onSearchQualification = this.onSearchQualification.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onSearchSubmitFilter = this.onSearchSubmitFilter.bind(this);
    this.onSearchFilterLabel = this.onSearchFilterLabel.bind(this);
    this.onSearchFilterSection = this.onSearchFilterSection.bind(this);
  }
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * section ....
   * @public
   * @method
   * @name onSearchFilterSection
   * @param { string }  param
   * @param { number }  index
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onSearchFilterSection = (param: string, index: number) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @name sectionFilter
     * @type any[]
     */
    const sectionFilter: boolean[] = this.state.sectionFilter;

    /**
     * @constant
     * @name sectionString
     * @type string
     */
    const sectionString: string[] = this.state.sectionString;

    sectionFilter[index] = !sectionFilter[index];

    if (sectionFilter[index] === true) {
      sectionString[index] = param;
    } else {
      sectionString[index] = "";
    }

    if (!Lodash.isEmpty(sectionString.filter((elem: any) => elem !== ""))) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => sectionString);
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        sectionStrings:
          "&sections=" +
          sectionString.filter((elem: any) => elem !== "").toString(),
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ sectionString: [] }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ sectionStrings: "" }));
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => sectionFilter);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorDateRange: false,
      onresetoff: false,
      onresetSuccess: false,
      noSearchById: true,
      noIncidents: false,
    }));
  };
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * label ....
   * @public
   * @method onSearchFilterLabel
   * @param { string }  param
   * @param { number }  index
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onSearchFilterLabel = (param: string, index: number) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name labelFilter
     * @type any[]
     */
    const labelFilter: any[] = this.state.labelFilter;
    /**
     * @constant
     * @name labelString
     * @type string
     */
    const labelString: string[] = this.state.labelString;
    {
      /** boucle */
    }
    labelFilter[index] = !labelFilter[index];

    if (labelFilter[index] === true) {
      labelString[index] = param;
    } else {
      labelString[index] = "";
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => labelFilter);

    if (!Lodash.isEmpty(labelString.filter((elem: any) => elem !== ""))) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => labelString);
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        labelStrings:
          "&labels=" +
          labelString.filter((elem: any) => elem !== "").toString(),
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ labelString: [] }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ labelStrings: "" }));
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorDateRange: false,
      onresetoff: false,
      onresetSuccess: false,
      noSearchById: true,
      noIncidents: false,
    }));
  };
  /**
   * Cette méthode mute le state
   * @action " Changement  "
   * @method
   * @name onSearchSubmitFilter
   * @param { any }  event
   * @return { void }
   */
  public onSearchSubmitFilter = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorDateRange: false,
      noIncidents: false,
    }));
    /**
     * @constant
     * @name minDate
     * @type Date
     */
    const minDate: any = moment(this.state.startDate).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    /**
     * @constant
     * @name maxDate
     * @type Date
     */
    const maxDate: any = moment(this.state.endDate).format(
      "YYYY-MM-DDTHH:mm:ss"
    );

    /**
     * @constant
     * @name action
     * @type string
     */
    let action: string = "";

    if (
      !Lodash.isEqual(minDate, "Invalid date") &&
      !Lodash.isEqual(maxDate, "Invalid date")
    ) {
      if (minDate < maxDate) {
        {
          /** Empêcher la mutation du state */
        }

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ loading: true }));

        action =
          "&minDate=" +
          minDate +
          "&maxDate=" +
          maxDate +
          this.state.cameraString +
          this.state.sectionStrings +
          this.state.labelStrings +
          this.state.qualificationString.toString().split(",").join("");

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          isFilter: false,
          loading: false,
          noSearchById: true,
          sorting: action,
          fiterInfos: action,
        }));
      } else if (minDate === maxDate) {
        {
          /** Empêcher la mutation du state */
        }

        action =
          this.state.cameraString +
          this.state.sectionStrings +
          this.state.labelStrings +
          this.state.qualificationString.toString().split(",").join("");

        if (action === "") {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            isFilter: false,
            loading: false,
            noSearchById: true,
            onresetoff: false,
            onresetSuccess: false,
            sorting: "orderBy=start_time&direction=DESC",
            fiterInfos: action,
          }));
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            isFilter: false,
            loading: false,
            noSearchById: true,
            onresetoff: false,
            onresetSuccess: false,
            sorting: action,
            fiterInfos: action,
          }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorDateRange: true }));
      }
    } else if (
      Lodash.isEqual(minDate, "Invalid date") &&
      !Lodash.isEqual(maxDate, "Invalid date")
    ) {
      {
        /** Empêcher la mutation du state */
      }

      action =
        "&maxDate=" +
        maxDate +
        this.state.cameraString +
        this.state.sectionStrings +
        this.state.labelStrings +
        this.state.qualificationString.toString().split(",").join("");

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        isFilter: false,
        loading: false,
        noSearchById: true,
        onresetoff: false,
        onresetSuccess: false,
        sorting: action,
        fiterInfos: action,
      }));
    } else if (
      !Lodash.isEqual(minDate, "Invalid date") &&
      Lodash.isEqual(maxDate, "Invalid date")
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ errorDateRange: true }));
    } else if (
      Lodash.isEqual(minDate, "Invalid date") &&
      Lodash.isEqual(maxDate, "Invalid date")
    ) {
      {
        /** Empêcher la mutation du state */
      }

      action =
        this.state.cameraString +
        this.state.sectionStrings +
        this.state.labelStrings +
        this.state.qualificationString.toString().split(",").join("");

      if (action === "") {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: "orderBy=start_time&direction=DESC",
          fiterInfos: action,
        }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          isFilter: false,
          noIncidents: false,
          noSearchById: true,
          loading: false,
          onresetoff: false,
          onresetSuccess: false,
          sorting: action,
          fiterInfos: action,
        }));
      }
    }
  };
  /**
   * Changement des date avec le date picker
   * @external { react-datepicker }
   * @public
   * @method onStartDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onStartDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      startDate: value,
      errorDateRange: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      noIncidents: false,
    }));
  }
  /**
   * Changement des date avec le date picker
   * @external { react-datepicker }
   * @public
   * @method
   * @name onEndDateChange
   * @param { any } value
   * @infos "https://reactjs.org"
   */
  public onEndDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      endDate: value,
      errorDateRange: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      noIncidents: false,
    }));
  }
  /**
   * @method onUpdateScrollTop
   * @description: MAJ du scrollIncident
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateScrollTop = (target: any) =>
    this.setState((state: any) => ({ scrollIncident: Number(target) }));

  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * qualification ....
   * @public
   * @method onSearchQualification
   * @param { string }  param
   * @param { number }  index
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onSearchQualification = (param: string, index: number) => (
    event: any
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @name qualification
     * @type any[]
     */
    const qualification: boolean[] = this.state.qualification;

    qualification[index] = !qualification[index];
    /**
     * @constant
     * @name qualificationString
     * @type any[]
     */

    const qualificationString: string[] = this.state.qualificationString;

    if (qualification[index] === true) {
      if (param === "À qualifier") {
        qualificationString[index] = "&aQualified=true";
      } else if (param === "Avéré") {
        qualificationString[index] = "&truePositive=true";
      } else if (param === "Fausse alerte") {
        qualificationString[index] = "&falsePositive=true";
      } else if (param === "Inhibé par SAE") {
        qualificationString[index] = "&autoQualifiedSae=true";
      } else if (param === "Inhibé par WEB") {
        qualificationString[index] = "&autoQualifiedWeb=true";
      } else if ("Filtré par WEB") {
        qualificationString[index] = "&autoQualifiedFilter=true";
      }
    } else {
      qualificationString[index] = "";
    }

    if (!Lodash.isEmpty(qualificationString)) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => qualificationString);
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ qualificationString: [] }));
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => qualification);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorDateRange: false,
      onresetoff: false,
      onresetSuccess: false,
      noSearchById: true,
      noIncidents: false,
    }));
  };
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * caméra ....
   * @public
   * @method
   * @name onGetValue
   * @param { string }  param
   * @param { number }  index
   * @param { any }  value
   * @infos "https://reactjs.org"
   */
  public onGetValue = (value: any): void => {
    {
      /** Vérification de la variable */
    }

    if (!Lodash.isEmpty(value) && !Lodash.isUndefined(value)) {
      /**
       * @constant
       * @name valueString
       */
      const valueString: string = "&cameraCodes=" + value;

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ cameraString: valueString }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({ cameraString: "" }));
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      loading: false,
      noIncidents: false,
      noSearchById: true,
      onresetoff: false,
      onresetSuccess: false,
      errorSearchIncident: false,
      errorDateRange: false,
      selectedValueName: "someEffect",
    }));
  };

  /**
   * @method onPenSearchIncidents
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onPenSearchIncidents = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ onpensearchboolean: true }));
  };
  /**
   * @method onPenSearchIncidentsClose
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onPenSearchIncidentsClose = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      onpensearchboolean: false,
      onresetoff: false,
      onresetSuccess: false,
      noSearchById: true,
      errorSearchIncident: false,
      noIncidents: false,
    }));
  };

  /**
   * Modification de l'état du filtre
   * @public
   * @method onFilter
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onFilter = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ isFilter: !this.state.isFilter }));
    // this.onCleanFilter();
    {
      /** Empêcher la mutation du state */
    }
    // this.setState((state: any):any =>({errorDateRange:false, onresetSuccess:false,openHoverCard:false,noIncidents:false,}))
  };

  /**
   * @method onOpenhoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpenhoverCard = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      openHoverCard: true,
      onresetoff: false,
      onresetSuccess: false,
    }));
  };
  /**
   * @method onDeletedSimulation
   * @param { any } event
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onDeletedSimulation = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({ loading: true, noSearchById: true }));
    // action creator
    this.props.ImpactFakeDeletedActionCreator(param).then(() => {
      this.props
        .IncidentHistoryLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() => this.setState((state: any): any => ({ loading: false })));
    });
  };
  /**
   * @method onClosehoverCard
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClosehoverCard = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      openHoverCard: false,
      onresetoff: false,
      onresetSuccess: false,
    }));
  };
  /**
   * @method onExplorerSearch
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExplorerSearch = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      loading: true,
      noIncidents: false,
      onresetoff: false,
      onresetSuccess: false,
    }));

    this.props
      .SearchIncidentByIdActionCreator(Number(this.state.explorersearch))
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };

  /**
   * @method onClearIncidentSearch
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClearIncidentSearch = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      explorersearch: "",
      noIncidents: false,
      onresetoff: false,
      onresetSuccess: false,
    }));

    {
      /** Empêcher la mutation du state */
    }

    this.props
      .IncidentHistoryLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.sorting
      )
      .then(() => this.setState((state: any) => ({ loading: false })));
  };
  /**
   * @method onExplorerSearchChange
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExplorerSearchChange = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: event.target.value });
    {
      /** Empêcher la mutation du state */
    }
    this.setState((stae: any) => ({
      errorSearchIncident: false,
      onresetoff: false,
      onresetSuccess: false,
    }));
  };
  /**
   * Extraire l'incident au format vidéo
   * @public
   * @method onExtractVideo
   * @param { any } incidents
   * @param { number } index
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExtractVideo = (incidents: any, index: number) => (event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      loading: true,
      noIncidents: false,
      noSearchById: true,
      onresetoff: false,
    }));
    {
      /** action creator */
    }

    this.props
      .ReplayDownloadActionCreator(
        Number(incidents.id),
        incidents.label,
        incidents.startTime,
        incidents.camera.code
      )
      .then(() =>
        setTimeout(
          () => this.setState((state: any) => ({ loading: false })),
          2000
        )
      );
  };

  /**
   * Extraire l'incident au format pdf
   * @public
   * @method
   * @name onExtractImpact
   * @param { number } param
   * @param { number } index
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onExtractImpact = (param: number, index: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    // event.preventDefault();

    this.setState((state: any): any => ({
      errorExtractionVideo: false,
      errorExtractionPdf: false,
      onresetoff: false,
      noSearchById: true,
      noIncidents: false,
      errorSearchIncident: false,
      loading: true,
    }));
    /**
     * @constant
     * @name actionLoading
     * @type boolean[]
     */
    const actionLoading: boolean[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i <= Math.ceil(this.state.actionLoading.length); i++) {
      actionLoading.push(false);
    }

    actionLoading[index] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ actionLoading });

    {
      /** appel de l'action */
    }
    this.props
      .ExtractorPdfIncidentActionCreator(param)
      .then(() => this.setState((state: any): any => ({ loading: false })));
  };
  /**
   * Choisir un incident
   * @public
   * @method
   * @name onIncidentActif
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onIncidentActif = (param: any) => (event: any) => {
    /**
     * @constant
     * @name arrayOfIncident
     * @type any[]
     */
    const arrayOfIncident: any[] = [];
    const errorExtractionVideo: boolean = false;
    const errorExtractionPdf: boolean = false;
    const paramArray: number = param;

    if (!Lodash.isNull(this.state.arrayOfIncident)) {
      {
        /**  test du type ou existance du paramètre */
      }
      for (let i = 1; i <= Math.ceil(this.state.arrayOfIncident.length); i++) {
        arrayOfIncident.push(false);
        // errorExtractionVideo.push(false);
      }

      arrayOfIncident[param] = !this.state.arrayOfIncident[param];

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any) => ({
        arrayOfIncident,
        errorExtractionVideo,
        errorExtractionPdf,
        paramArray,
      }));
    }
  };
  /**
   * Choisir un incident
   * @public
   * @deprecated
   * @method
   * @name onTextOver
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onTextOver = (param: any, stack: string) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    switch (stack) {
      case "alarm":
        /**
         * @constant
         * @name alarmOver
         * @description : Faire apparaitre le texte lors d'un EventListner
         */
        const alarmOver: boolean[] = [];

        {
          /** boucle */
        }
        for (let i = 0; i <= Math.ceil(this.state.alarmOver); i++) {
          alarmOver.push(false); // remplir le tableau
        }
        alarmOver[param] = !this.state.alarmOver[param]; //

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ alarmOver }));

        break;
      case "date":
        /**
         * @constant
         * @name startTimeOver
         * @description : Faire apparaitre le texte lors d'un EventListner
         */
        const startTimeOver: boolean[] = [];

        {
          /** boucle */
        }
        for (let i = 0; i <= Math.ceil(this.state.startTimeOver); i++) {
          startTimeOver.push(false); // remplir le tableau
        }
        startTimeOver[param] = !this.state.startTimeOver[param]; //

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ startTimeOver }));

        break;
      case "section":
        /**
         * @constant
         * @name sectionOver
         * @description : Faire apparaitre le texte lors d'un EventListner
         */
        const sectionOver: boolean[] = [];

        {
          /** boucle */
        }
        for (let i = 0; i <= Math.ceil(this.state.sectionOver); i++) {
          sectionOver.push(false); // remplir le tableau
        }
        sectionOver[param] = !this.state.sectionOver[param]; //

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ sectionOver }));

        break;

      default:
        break;
    }
  };
  /**
   * Triage par ordre alphanumérique / date
   * @method onSortingBy
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSortingBy = (action: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [false, false, false, false];
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      filter,
      sorting: action + this.state.fiterInfos,
    }));
  };
  /**
   * Activation front des tri
   * @method onOpen
   * @param {number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onOpen = (param: number) => (event: any): void => {
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];
    /**
     * @constant
     * @name filterHeader
     * @type any[]
     */
    const filterHeader: any[] = [];

    {
      /** boucle */
    }
    for (let i = 1; i <= Math.ceil(this.state.filter); i++) {
      filter.push(false);
      filterHeader.push(false);
    }

    filter[param] = true;
    filterHeader[param] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ filter, filterHeader }));
  };

  /**
   * Changement de l'etat de l'onglet
   * @public
   * @method
   * @name onClose
   * @param { any }  event
   * @infos "https://reactjs.org"
   */
  public onClose = (event: any): void => {
    event.preventDefault();
    /**
     * @constant
     * @name filter
     * @type any[]
     */
    const filter: any[] = [];
    /**
     * @constant
     * @name filterHeader
     * @type any[]
     */
    const filterHeader: any[] = [];

    for (let i = 1; i <= Math.ceil(this.state.filter); i++) {
      filter.push(false);
      filterHeader.push(false);
    }

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ filter, filterHeader }));
  };
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({ currentPageNumbers: Number(target) }));

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({
      filter: [false, false, false, false],
      filterHeader: [false, false, false, false],
      noIncidents: false,
      onresetoff: false,
      noSearchById: true,
    }));
    {
      /** cancel debounce function */
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    const User: any = Utils.createdUserRoles();

    if (
      Utils.simpleAuthorizationIsAllowed(User, [
        Enums.AuthorizationRightsEnums
          .EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_SAE,
      ])
    ) {
      this.setState((state: any) => ({
        QualificationState: [
          ...state.QualificationState,
          i18next.t("inhibe par sae"),
        ],
      }));
    }
    if (
      Utils.simpleAuthorizationIsAllowed(User, [
        Enums.AuthorizationRightsEnums
          .EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_WEB,
      ])
    ) {
      this.setState((state: any) => ({
        QualificationState: [
          ...state.QualificationState,
          i18next.t("inhibe par web"),
        ],
      }));
    }
    if (
      Utils.simpleAuthorizationIsAllowed(User, [
        Enums.AuthorizationRightsEnums
          .EXPLOITATIOIN_EXPLORER_FILTER_QUALIFIED_FILTER,
      ])
    ) {
      this.setState((state: any) => ({
        QualificationState: [
          ...state.QualificationState,
          i18next.t("filtre par web"),
        ],
      }));
    }

    // QualificationState: [
    //   i18next.t("a qualifier"),
    //   i18next.t("fausse alerte"),
    //   i18next.t("avere"),
    //   i18next.t("inhibe par sae"),
    //   i18next.t("inhibe par web"),
    //   i18next.t("filtre par web"),
    // ],

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      loading: true,
      noSearchById: true,
      onresetoff: false,
    }));

    {
      /** Action creator */
    }
    this.props
      .IncidentHistoryLoadedActionCreator(
        this.state.currentPageNumbers - 1,
        this.state.itemsPerPage,
        this.state.sorting
      )
      .then(() => this.setState({ loading: false }));
    {
      /** Action creator */
    }
    this.props.IncidentTypesLoadedActionCreator(); // Chargement de la liste des types d'incidents
    this.props.ExtractorCameraListActionCreator(); // Chargement de la liste des caméras
    this.props.SystemSettingsActionCreator(); // Chargement des sections ( Tube Nord , Tube Sud , ...)
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.data !== this.props.data) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (
        !Lodash.isUndefined(nextProps.data) &&
        !Lodash.isUndefined(nextProps.data.content)
      ) {
        /**
         * @constant
         * @name IncidentTerminated
         * @type any[]
         */
        const IncidentTerminated: any[] = Utils.transformObjectToArray(
          nextProps.data.content
        ).filter((elem: any) => elem.terminated);

        {
          /** Empêcher la mutation du state */
        }

        if (
          !Lodash.isUndefined(IncidentTerminated) &&
          !Lodash.isEmpty(IncidentTerminated)
        ) {
          /**
           * @constant
           * @deprecated
           * @name alarmOver
           * @type boolean[]
           */
          const alarmOver: boolean[] = [];
          /**
           * @constant
           * @deprecated
           * @name startTimeOver
           * @type boolean[]
           */
          const startTimeOver: boolean[] = [];
          /**
           * @constant
           * @deprecated
           * @name sectionOver
           * @type boolean[]
           */
          const sectionOver: boolean[] = [];
          /**
           * @constant
           * @name arrayOfIncident
           * @type boolean[]
           */
          const arrayOfIncident: boolean[] = [];

          {
            /** boucle */
          }
          for (let i = 0; i <= Math.ceil(IncidentTerminated.length); i++) {
            alarmOver.push(false); // Event Qualification
            startTimeOver.push(false); // Event Date
            sectionOver.push(false); // Event nom de la section
            arrayOfIncident.push(false); // Tableau des incidents
          }
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            alarmOver,
            arrayOfIncident,
            explorerData: IncidentTerminated,
            noSearchById: true,
            // itemsPerPage:nextProps.data.totalElements,
            sectionOver,
            startTimeOver,
            // totalElements:nextProps.data.totalElements,
            totalElements: nextProps.data.totalElements,
          }));
        }
        {
          /** vérification de l'existence de l'élement  */
        }
        if (nextProps.data.content.length === 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            noIncidents: true,
            noSearchById: true,
            errorserver: false,
          }));
        }
      }
    } else if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existance */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.dataVideoError !== this.props.dataVideoError) {
      if (!Lodash.isUndefined(nextProps.dataVideoError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState({
          errorExtractionVideo: true,
          errorExtractionPdf: false,
        });
      }
    } else if (nextProps.dataPdfError !== this.props.dataPdfError) {
      if (!Lodash.isUndefined(nextProps.dataPdfError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState({
          errorExtractionVideo: false,
          errorExtractionPdf: true,
        });
      }
    } else if (nextProps.section !== this.props.section) {
      this.onSectionFilter(nextProps.section);
    } else if (nextProps.incidentTypeList !== this.props.incidentTypeList) {
      this.onlabelFilter(nextProps.incidentTypeList);
    } else if (nextProps.searchData !== this.props.searchData) {
      if (!Lodash.isUndefined(nextProps.searchData)) {
        {
          /** Empêcher la mutation du state */
        }

        if (!Lodash.isEmpty(nextProps.searchData)) {
          /**
           * @constant
           * @deprecated
           * @name alarmOver
           * @type boolean[]
           */
          const alarmOver: boolean[] = [];
          /**
           * @constant
           * @deprecated
           * @name startTimeOver
           * @type boolean[]
           */
          const startTimeOver: boolean[] = [];
          /**
           * @constant
           * @deprecated
           * @name sectionOver
           * @type boolean[]
           */
          const sectionOver: boolean[] = [];
          /**
           * @constant
           * @name arrayOfIncident
           * @type boolean[]
           */
          const arrayOfIncident: boolean[] = [];

          const searchDataArray: any[] = [];

          const searchDataZ: any[] = searchDataArray.concat(
            nextProps.searchData
          );

          {
            /** boucle */
          }
          if (!Lodash.isUndefined(searchDataZ)) {
            for (let i = 0; i <= Math.ceil(searchDataZ.length); i++) {
              alarmOver.push(false); // Event Qualification
              startTimeOver.push(false); // Event Date
              sectionOver.push(false); // Event nom de la section
              arrayOfIncident.push(false); // Tableau des incidents
            }
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              alarmOver,
              arrayOfIncident,
              explorerData: searchDataZ,
              noSearchById: false,
              // itemsPerPage:nextProps.data.totalElements,
              sectionOver,
              startTimeOver,
              // totalElements:nextProps.data.totalElements,
              totalElements: searchDataZ.length,
            }));
          }
        }
      }
    } else if (nextProps.searchError !== this.props.searchError) {
      if (!Lodash.isUndefined(nextProps.searchError)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState({ errorSearchIncident: true });
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison */
    }
    if (prevState.currentPageNumbers !== this.state.currentPageNumbers) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .IncidentHistoryLoadedActionCreator(
          this.state.currentPageNumbers - 1,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() => this.setState({ loading: false }))
        .then(() => {
          if (this.state.onresetoff) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any) => ({ onresetSuccess: true }));
          }
        });
    } else if (prevState.sorting !== this.state.sorting) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ loading: true }));
      {
        /** Action creator */
      }
      this.props
        .IncidentHistoryLoadedActionCreator(
          0,
          this.state.itemsPerPage,
          this.state.sorting
        )
        .then(() =>
          this.setState((state: any): any => ({
            currentPageNumbers: 1,
            loading: false,
          }))
        )
        .then(() => {
          if (this.state.onresetoff) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any) => ({ onresetSuccess: true }));
          }
        });
    } else if (prevState.totalElements !== this.state.totalElements) {
      {
        /** Empêcher la mutation du state */
      }
      // this.setState((state: any):any =>({loading: true}));
      {
        /** Action creator */
      }
      if (this.state.noSearchById) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ loading: true }));
        this.props
          .IncidentHistoryLoadedActionCreator(
            0,
            this.state.itemsPerPage,
            this.state.sorting
          )
          .then(() =>
            this.setState((state: any): any => ({
              currentPageNumbers: 1,
              loading: false,
            }))
          );
      }
    }
  }

  /**
   * Changement d'etat
   * @public
   * @method onQualiFilter
   * @param { array <any> } Elem
   */
  public onQualiFilter = (Elem: any[]) => {
    {
      /**  test du type ou existance du paramètre */
    }

    if (Lodash.isArray(Elem) && !Lodash.isEmpty(Elem)) {
      /**
       * @constant
       * @name qualificationString
       * @type string[]
       */
      const qualificationString: string[] = [];

      for (let i = 0; i < Math.ceil(Elem.length); i++) {
        qualificationString[i] = "";
      }

      {
        /** Empêcher la mutation du state */
      }

      this.setState((state: any): any => ({ qualificationString }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        qualification: [false, false, false],
      }));
      {
        /** Empêcher la mutation du state */
      }
    }
  };
  /**
   * Changement d'etat
   * @public
   * @method onSectionFilter
   * @param { array <any> } Elem
   */
  public onSectionFilter = (Elem: any[]) => {
    {
      /**  test du type ou existance du paramètre */
    }

    if (Lodash.isArray(Elem) && !Lodash.isEmpty(Elem)) {
      /**
       * @constant
       * @name sectionFilter
       * @type any[]
       */
      const sectionFilter: boolean[] = [];
      /**
       * @constant
       * @name sectionString
       * @type any[]
       */
      const sectionString: any[] = [];

      for (let i = 0; i < Math.ceil(Elem.length); i++) {
        sectionFilter[i] = false;
        sectionString[i] = "";
      }

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ sectionString }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ sectionStrings: "" }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ sectionFilter }));
    }
  };
  /**
   * Changement d'etat
   * @public
   * @method onlabelFilter
   * @param { array <any> } Elem
   * @infos "https://reactjs.org"
   */
  public onlabelFilter = (Elem: any[]) => {
    {
      /**  test du type ou existance du paramètre */
    }
    if (Lodash.isArray(Elem) && !Lodash.isEmpty(Elem)) {
      /**
       * @constant
       * @name labelFilter
       * @type any[]
       */
      const labelFilter: boolean[] = [];
      /**
       * @constant
       * @name labelString
       * @type any[]
       */
      const labelString: any[] = [];

      {
        /** vérification de l'existance de la variable */
      }

      for (let i = 0; i < Math.ceil(Elem.length); i++) {
        labelFilter[i] = false; //
        labelString[i] = ""; //
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ labelString }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ labelStrings: "" }));
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ labelFilter }));
    }
  };
  // des anciennes méthodes
  /**
   * Manipulation des données et changement de l'etat de l'onglet
   * date, caméra, ....
   * @public
   * @method onReset
   * @param { any }  event
   * @param { string }  action
   * @infos "https://reactjs.org"
   */
  public onReset = (action: string) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    this.onQualiFilter(this.state.qualification);
    this.onlabelFilter(this.state.labelFilter);
    this.onSectionFilter(this.state.sectionFilter);

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));
    this.props
      .IncidentHistoryLoadedActionCreator(0, this.state.itemsPerPage, action)
      .then(() =>
        this.setState((state: any) => ({
          onresetoff: true,
          loading: false,
          onresetSuccess: false,
          endDate: "",
          startDate: "",
          explorersearch: "",
          fiterInfos: "",
          selectedValueName: "noData",
          currentPageNumbers: 1,
          sorting: action,
        }))
      );
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        // nouvelle //
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber}
        onOpen={this.onOpen} //
        onClose={this.onClose} // fermeture
        onSortingBy={this.onSortingBy}
        onTextOver={this.onTextOver}
        onIncidentActif={this.onIncidentActif}
        onExtractImpact={this.onExtractImpact}
        onExtractVideo={this.onExtractVideo}
        onDeletedSimulation={this.onDeletedSimulation}
        onUpdateScrollTop={this.onUpdateScrollTop}
        //
        onPenSearchIncidents={this.onPenSearchIncidents}
        onPenSearchIncidentsClose={this.onPenSearchIncidentsClose}
        onOpenhoverCard={this.onOpenhoverCard}
        onClosehoverCard={this.onClosehoverCard}
        onFilter={this.onFilter}
        onReset={this.onReset}
        //
        onExplorerSearch={this.onExplorerSearch}
        onExplorerSearchChange={this.onExplorerSearchChange}
        onClearIncidentSearch={this.onClearIncidentSearch}
        //
        onGetValue={this.onGetValue}
        onSearchQualification={this.onSearchQualification}
        onEndDateChange={this.onEndDateChange}
        onStartDateChange={this.onStartDateChange}
        onSearchSubmitFilter={this.onSearchSubmitFilter}
        onSearchFilterLabel={this.onSearchFilterLabel}
        onSearchFilterSection={this.onSearchFilterSection}
      />
    );
  }
}

/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    cameraList: state.ExtractorCameraList.data,
    data: state.ExploreLoaded.data,
    dataPdf: state.ExtractorPdfIncident.data,
    dataPdfError: state.ExtractorPdfIncident.error,
    dataVideo: state.ExtractorVideo.data,
    dataVideoError: state.ExtractorVideo.error,
    error: state.ExploreLoaded.error,
    incidentTypeList: state.IncidentTypesLoaded.data,
    searchData: state.SearchIncidentById.data,
    searchError: state.SearchIncidentById.error,
    section: state.SystemSettings.data,
  };
}

export default connect(mapStateToProps, {
  SearchIncidentByIdActionCreator,
  SystemSettingsActionCreator,
  ImpactFakeDeletedActionCreator,
  IncidentHistoryLoadedResetActionCreator,
  IncidentHistoryLoadedActionCreator,
  ExtractorPdfIncidentActionCreator,
  ExtractorVideoActionCreator,
  IncidentTypesLoadedActionCreator,
  ExtractorCameraListActionCreator,
  ReplayDownloadActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/explorer/home/container.tsx